import { type SliderProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import ControlledClassSlider from './ClassSlider';

type LateScoreSliderProps = SliderProps & { name: string };
const LateScoreSlider = (props: LateScoreSliderProps) => {
    const { t } = useTranslation('calendar');
    return (
        <ControlledClassSlider
            inputLabel={t('lms-attendance-sync-tardy-score')}
            helperText={t('lms-attendance-sync-tardy-score-helper')}
            {...props}
            min={0}
            max={100}
            step={5}
            marks={[
                { value: 0, label: '0%' },
                { value: 20, label: '20%' },
                { value: 40, label: '40%' },
                { value: 60, label: '60%' },
                { value: 80, label: '80%' },
                { value: 100, label: '100%' }
            ]}
            valueLabelDisplay="auto"
            valueLabelFormat={(value) => `${value}%`}
            getAriaLabel={(value) => `${value}%`}
        />
    );
};
export default LateScoreSlider;
